import axios from '@axios'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchCustomerProfileLists(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('customer/customer/profile-change/list', { params: queryParams })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
  },
}
